function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { isEmpty, noop } from 'lodash';
import Icon from "../../Icon/Icon";
import Addresses from "../../../utils/Addresses";
import ContactInformation from "../../Contact/ContactInformation/ContactInformation";
import HoursOfOperation from "../../HoursOfOperation/HoursOfOperation";
import Arrays from "../../../utils/Arrays";
import ServiceTypes from "../../../utils/ServiceTypes";
import ProviderCardAddRemoveButton from "../components/ProviderCardAddRemoveButton/ProviderCardAddRemoveButton";
import Popover from "../../Popover/Popover";
import InfoPanel from "../../InfoPanel/InfoPanel";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProviderCard = _ref => {
  let {
    id,
    className = "",
    disableSelection = false,
    isSelected = false,
    provider,
    selectedServiceType,
    unselectable = false,
    serve = false,
    tooltipText = undefined,
    originLatLng = [],
    onAddProvider = noop,
    onDetailClick = noop,
    onRemoveProvider = noop
  } = _ref;
  const calculatedDistances = provider.addresses.map(address => Addresses.calculateDistance(address, originLatLng));
  const [closestDistanceAddress, setClosestDistanceAddress] = useState(Addresses.findClosestDistanceAddress(calculatedDistances));
  const [currentOriginLatLng, setCurrentOriginLatLng] = useState(originLatLng);
  useEffect(() => {
    if (originLatLng[0] !== currentOriginLatLng[0] || originLatLng[1] !== currentOriginLatLng[1]) {
      const updatedDistances = provider.addresses.map(address => Addresses.calculateDistance(address, originLatLng));
      const updatedClosestDistanceAddress = Addresses.findClosestDistanceAddress(updatedDistances);
      setClosestDistanceAddress(updatedClosestDistanceAddress);
      setCurrentOriginLatLng(originLatLng);
    }
  }, [originLatLng, provider]);
  const handleAddProvider = destinationLatLng => {
    const distance = Addresses.getDistanceInMiles(currentOriginLatLng, destinationLatLng, {
      format: "float"
    });
    const providerWithDistance = _objectSpread(_objectSpread({}, provider), {}, {
      distance
    });
    onAddProvider(providerWithDistance);
  };
  const handleRemoveProvider = () => {
    onRemoveProvider(provider);
  };
  const handleDetailClick = () => {
    onDetailClick(provider);
  };
  const generateMoreAddressCountText = () => {
    let text;
    const addressLength = provider.addresses.length;
    if (addressLength > 1) {
      text = "".concat(addressLength - 1, " more");
    }
    return text;
  };
  const detailsProps = !onDetailClick ? {} : {
    onClick: handleDetailClick,
    onKeyPress: handleDetailClick,
    role: "button",
    tabIndex: 0
  };
  const isInNetworkGroup = provider.licensed;
  const providerServiceTypes = provider.service_types;
  const serviceTypes = ServiceTypes.matchingServiceTypes(selectedServiceType, providerServiceTypes);
  const svcTypeBanner = ServiceTypes.serviceTypeBanner(serviceTypes);
  const {
    email_addresses,
    hours,
    phone_numbers,
    website_url
  } = provider;
  const showContactInfo = !isEmpty(email_addresses) || !isEmpty(phone_numbers) || !isEmpty(website_url);
  const addressCount = generateMoreAddressCountText();
  const location = _objectSpread({
    hours
  }, closestDistanceAddress);
  const cardClass = () => cn("flex flex-row flex-no-wrap w-full", className);
  return /*#__PURE__*/_jsx("div", {
    className: "border border-solid border-table-border-color",
    children: /*#__PURE__*/_jsx(Popover, {
      tooltipText: tooltipText,
      id: id,
      hiddenTooltip: !serve || !tooltipText,
      childrenClassName: "w-full flex-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: cardClass(),
        id: "anchor-id-".concat(id),
        children: [/*#__PURE__*/_jsx("div", {
          className: cn("w-full text-text-blue", {
            "opacity-50": disableSelection
          }),
          children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
            className: cn("p-4", {
              "cursor-default": disableSelection
            })
          }, detailsProps), {}, {
            children: [serve && /*#__PURE__*/_jsxs("div", {
              className: "",
              children: [/*#__PURE__*/_jsx(Icon, {
                className: "float-right",
                color: "dark-border-grey",
                icon: "Radar",
                size: 82
              }), /*#__PURE__*/_jsxs("div", {
                className: "mb-4 flex",
                children: [/*#__PURE__*/_jsx(Icon, {
                  className: "my-auto",
                  color: "".concat(isInNetworkGroup ? "united-blue" : "brand-blue"),
                  icon: "Radar",
                  size: 16
                }), /*#__PURE__*/_jsx(InfoPanel, {
                  message: "Serves this area",
                  showIcon: false
                })]
              })]
            }), !isInNetworkGroup && /*#__PURE__*/_jsxs("div", {
              className: "mb-1 text-sm flex",
              children: [/*#__PURE__*/_jsx(Icon, {
                className: "mr-2 my-auto",
                color: "brand-blue",
                icon: "OutOfNetwork"
              }), /*#__PURE__*/_jsx("p", {
                children: "Out of Network Organization"
              })]
            }), /*#__PURE__*/_jsx("h4", {
              className: "text-xl mb-2",
              children: provider.name
            }), !isEmpty(svcTypeBanner) && /*#__PURE__*/_jsx("p", {
              className: "text-sm text-purple mb-3",
              children: svcTypeBanner
            }), showContactInfo && /*#__PURE__*/_jsx(ContactInformation, {
              addressCount: addressCount,
              addresses: [location],
              email_addresses: email_addresses,
              hideLabels: true,
              hours: hours,
              isInNetworkGroup: isInNetworkGroup,
              originLatLng: currentOriginLatLng,
              phone_numbers: [Arrays.findPrimaryOrFirst(phone_numbers)],
              showContactInfoHeader: false,
              showLocationHours: false,
              website_url: website_url,
              serve: serve
            }), /*#__PURE__*/_jsx(HoursOfOperation, {
              hours: location.hours || location.hours_of_operation,
              isInNetworkGroup: isInNetworkGroup,
              showAll: false,
              showHoursIcon: true
            })]
          }))
        }), !disableSelection && !unselectable && /*#__PURE__*/_jsx(ProviderCardAddRemoveButton, {
          destinationLatLng: [closestDistanceAddress.latitude, closestDistanceAddress.longitude],
          distance: closestDistanceAddress.distance,
          onAddClick: handleAddProvider,
          onRemoveClick: handleRemoveProvider,
          selected: isSelected
        })]
      })
    })
  });
};
ProviderCard.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  disableSelection: PropTypes.bool,
  isSelected: PropTypes.bool,
  onAddProvider: PropTypes.func,
  onDetailClick: PropTypes.func,
  onRemoveProvider: PropTypes.func,
  originLatLng: PropTypes.array,
  provider: PropTypes.shape({
    addresses: PropTypes.array,
    email_addresses: PropTypes.array,
    group_type: PropTypes.string,
    hours: PropTypes.object,
    licensed: PropTypes.bool,
    name: PropTypes.string,
    phone_numbers: PropTypes.array,
    service_types: PropTypes.array,
    website_url: PropTypes.string
  }).isRequired,
  selectedServiceType: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })), PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })]).isRequired,
  unselectable: PropTypes.bool,
  serve: PropTypes.bool,
  tooltipText: PropTypes.string
};
export default ProviderCard;
//# sourceMappingURL=ProviderCard.js.map